<template>
  <v-dialog v-model="showDialog" persistent transition="dialog-transition" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ cartItemName }}</v-card-title>

      <v-form ref="form" @submit.prevent v-model="valid" lazy-validation>
        <v-text-field
          v-model.number="cartItem.price"
          type="number"
          autofocus
          label="Selling Price"
          :rules="priceRules"
          color="primary darken-4"
          prefix="GH₵"
          dense
          outlined
          style="width: 150px;"
          class="mx-auto"
          @input="updateIsSaved"
        ></v-text-field>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text color="grey darken-1" @click="closeDialog()" class="text-capitalize">Cancel</v-btn>

        <v-btn
          text
          color="primary darken-4"
          @click="savePrice()"
          class="text-capitalize"
          :disabled="isSaved"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditCartItemPriceDialog",

  data() {
    return {
      valid: true,
      id: null,
      price: null,
      isSaved: true
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setEditCartItemPriceDialog", false);
    },

    savePrice() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("updateCartItemPrice", { id: this.id, price: this.price })
          .then(() => {
            this.isSaved = true;
            this.closeDialog();
          });
      }
    },

    updateIsSaved(value) {
      this.isSaved = false;
      this.id = this.$store.state.carts.cartItem.id;
      this.price = value;
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.carts.editCartItemPriceDialog;
    },

    cartItemName() {
      return this.$store.state.carts.cartItem.name;
    },

    cartItem: {
      get() {
        return this.$store.state.carts.cartItem;
      },

      set: function(value) {
        this.price = value;
      }
    },

    priceRules() {
      const rules = [];

      const rule1 = v => !!v || "Update price";
      const rule2 = v => v > 0 || "Price must be greater than 0";
      rules.push(rule1);
      rules.push(rule2);

      if (this.$store.state.user.user_type === "Staff") {
        const rule3 = v =>
          v >= this.cartItem.set_price ||
          `Price must be ${this.cartItem.set_price} or above.`;
        rules.push(rule3);
      }
      return rules;
    }
  }
};
</script>

<style>
</style>